import { TextField } from "@mui/material";
import { forwardRef, useCallback, useImperativeHandle, useRef, useState } from "react";

/**
 * A TextField that passes all props down to the underlying TextField and exposes a checkValidity()-method to the specified ref.
 * If not valid, displays a red circle around the TextField.
 */
const ValidationTextField = forwardRef((props, ref) => {
  const [hasError, setHasError] = useState(false);

  const inputRef = useRef(null);

  const checkValidity = useCallback(() => {
    if (inputRef.current) {
      if (!inputRef.current.checkValidity()) {
        setHasError(true);
        return false;
      } else {
        setHasError(false);
        return true;
      }
    }
  }, [setHasError]);

  useImperativeHandle(ref, () => ({
    checkValidity: checkValidity
  }), [checkValidity]);

  return <TextField
    {...props}
    error={hasError}
    inputRef={inputRef}
  >
  </TextField>
});

export default ValidationTextField;